// extracted by mini-css-extract-plugin
module.exports = {"SubsidiaryMonitoringForm__loader":"SubsidiaryMonitoringForm_SubsidiaryMonitoringForm__loader__1bsd0"};